export const SUCCESS_CODE = 0
export const INVALID_TOKEN = -2
export const ERROR_CODE = -1
export const NOT_LOGIN = -3
export const GATE_ERROR_TOKEN = -4000
